import React, { useContext } from 'react';

import { getIn } from 'formik';
import { FormikContext } from 'formik';

import { LegacyText, LegacyBox, styled } from '@gogame/components';

import { useFormFieldGroupState } from './FormFieldGroup';

// TODO: add template

const ErrorText = styled(LegacyText)`
  color: ${(props) => props.theme.palette.error.main};
  font-size: 0.75em;
`;
const FromErrorMessage = ({
  children,
  name: _name,
  variant = 'body2',
  ...props
}) => {
  const { errors } = useContext(FormikContext);
  const { name } = useFormFieldGroupState({
    name: _name,
  });
  const error = getIn(errors, name);
  if (!error) {
    return null;
  }

  if (typeof children === 'function') {
    return children(error);
  }

  if (typeof error !== 'string') {
    return null;
  }

  return (
    <LegacyBox {...props}>
      <ErrorText variant={variant}>{error}</ErrorText>
    </LegacyBox>
  );
};

export default FromErrorMessage;
